import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

import type {
  OrganizationId,
  RemoveDeviceFromOrgRequestBody,
  RemoveDeviceFromOrgResponseType,
} from 'redux-store/slices/organizationOverview/types';

const removeDevicesFromOrganizationThunk = createAsyncThunk(
  'organizationOverview/removeDevicesFromOrganization',
  async ({
    organizationId,
    data,
  }: {
    organizationId: OrganizationId;
    data: RemoveDeviceFromOrgRequestBody;
  }): Promise<RemoveDeviceFromOrgResponseType> => {
    try {
      const apiPointName = 'removeDevicesFromOrganization';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        body: data,
        urlParams: { organizationId },
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default removeDevicesFromOrganizationThunk;
